<template>
  <main class="admin-report-page">
    <VolunteerStatsModal
      v-if="report === 'insights'"
      v-model="open"
      :locationId="locationId"
    />
    <AdminReportsModal
      v-else
      v-model="open"
      :locationId="locationId"
    />
  </main>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import VolunteerStatsModal from '@/components/VolunteerSummary/VolunteerStatsModal.vue'
import AdminReportsModal from '@/components/AdminReports/AdminReportsModal.vue'
import { getLocationId } from '@/utils/SessionDataHandler'

const route = useRoute()
const report = computed(() => route.meta.report)
// Prefer query param from manage-schedules embed; fall back to dashboard session storage.
const locationId = computed(() => {
  const fromQuery = route.query.locationid
  if (fromQuery != null && String(fromQuery).trim() !== '') {
    return String(fromQuery).trim()
  }
  return getLocationId()
})
const open = ref(true)

// Lets the embedding page (manage schedules) close its dialog when the modal is dismissed
watch(open, (isOpen) => {
  if (!isOpen && window.parent !== window) {
    window.parent.postMessage({ type: 'cs-close-external-page' }, '*')
  }
})
</script>
